"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('smart-optimization', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 45C27.2205 45 32.7272 40.8 32.7272 24C32.7272 7.2 27.2205 3 24 3C20.7794 3 15.2727 7.48302 15.2727 24C15.2727 40.517 20.7794 45 24 45Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10488 35C6.71518 37.8123 13.2476 40.421 28.3636 31.621C43.4797 22.821 44.5054 15.8123 42.8951 13C41.2848 10.1876 34.4978 7.72719 19.6364 16.3789C4.77493 25.0307 3.49462 32.1876 5.10488 35Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.10489 13C3.49463 15.8124 4.52029 22.8211 19.6364 31.6211C34.7525 40.4211 41.2848 37.8124 42.8951 35.0001C44.5054 32.1877 43.2251 25.0308 28.3636 16.379C13.5022 7.72728 6.7152 10.1877 5.10489 13Z",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;